module.exports = __webpack_public_path__ + "img/after-disabled.0f498a67.svg";